import React, { Component } from 'react';
import Button from 'antd/es/button/button';
import Form from 'antd/es/form';
import Input from 'antd/es/input';
import Card from 'antd/es/card';
import { Alert, Divider, Flex } from 'antd';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { RoutesConfig } from '../../../config';
import { withStore } from '../../../stores/utils/HOC';
import { IRootStoreProps, WithoutStore } from '../../../stores';
import { ILoginForm } from '../store';

const routesConfig = new RoutesConfig();

class Login extends Component<IRootStoreProps> {
  componentWillUnmount(): void {
    this.props.store.dispose();
  }

  render(): React.ReactNode {
    const { store } = this.props;

    return (
      <Card title="Вход" style={{ width: '100%' }}>
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          style={{ marginTop: 20 }}
          initialValues={{
            email: '',
            password: '',
          }}
          onFinish={store.auth.login}
          layout="vertical"
          autoComplete="off"
        >
          <Form.Item<ILoginForm>
            name="email"
            label="Email"
            rules={[
              { type: 'email', message: 'Этот Email не валидный!' },
              { required: true, message: 'Пожалуйста введите Email!' },
            ]}
            validateTrigger="onSubmit"
          >
            <Input />
          </Form.Item>
          <Form.Item<ILoginForm>
            label="Пароль"
            name="password"
            rules={[{ required: true, message: 'Пожалуйста введите ваш пароль!' }]}
            validateTrigger="onSubmit"
          >
            <Input.Password />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={store.loading} style={{ width: '100%', marginTop: 20 }}>
              {'Войти'}
            </Button>
          </Form.Item>
          {store.requestError && <Alert message="Error" description={store.requestError} type="error" showIcon />}
        </Form>
        <Flex justify="center" align="center">
          <Link to={routesConfig.forgotPassword}>
            <Button type="text">Забыли пароль?</Button>
          </Link>
          <Divider type={'vertical'} />
          <Link to={routesConfig.registration}>
            <Button type="text">Зарегистрироваться</Button>
          </Link>
        </Flex>
      </Card>
    );
  }
}

export const LoginPage: WithoutStore = withStore(observer(Login));
